import clsx from 'clsx'
import React, { FC } from 'react'

import { Icon } from '@/shared/ui/icon'

import cls from './top-panel.module.scss'

interface TopPanelProps {
	onClick?: () => void
	open: boolean
	name: string
	withMark: boolean
}

export const TopPanel: FC<TopPanelProps> = ({ onClick, open, withMark, name }) => (
	<div className={cls.topPanel} onClick={onClick}>
		<p className={clsx(cls.title, withMark && cls.title__withMark)}>{name}</p>
		<button type="button" className={clsx(cls.openButton, open && cls.openButton_active)}>
			<Icon name={'ArrowDown'} color={open && '#568dfe'} />
		</button>
	</div>
)
